export const NoAccessPageDE = {
  title: "You shall not pass!",
  subtitle:
    "Du bist leider nicht berechtigt, diese Seite zu sehen. Bitte wende dich an den <0>Customer Service</0>, wenn du Zugriff auf die Seite haben möchtest.",
  button: "Zum heo-Shop",
  mailSubject: "Anfrage Zugang zu Business Console",
};
